<template>
  <p>
    Showing
    <strong>{{ start }} - {{ Math.min(end, props.searchState.totalResults) }}</strong>
    out of <strong>{{ props.searchState.totalResults }}</strong> results
    <span v-if="props.searchState.searchTerm">
      using keyword(s): <em>"{{ props.searchState.searchTerm }}"</em></span
    >
  </p>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  searchState: {
    required: true,
    type: Object
  }
})

const start = computed(() => props.searchState.totalResults === 0 ? 0 : (props.searchState.current - 1) * props.searchState.resultsPerPage + 1)
const end = computed(() => props.searchState.totalResults <= props.searchState.resultsPerPage
        ? props.searchState.totalResults
        : start.value + props.searchState.resultsPerPage - 1)
</script>
